import { FeedItemT } from 'types/shared/core/Feeds';
import { Stack, useTheme } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { PostT } from 'types/shared/core/Post';
import { ComponentType } from 'react';
import FeedRow from './FeedRow';
import LoadMoreSentinel from './LoadMoreSentinel';
import { TransitionGroup } from 'react-transition-group';

export type FeedsPropsT = {
  listKey: string;
  feeds: FeedItemT[];
  perspective: 'teacherSide' | 'studentSide';
  canOpenPostViewer?: (post: PostT) => boolean;
  onClickPostViewer?: (post: PostT) => void;
  onEnd: () => void;
  onClick: (feedItem: FeedItemT) => void;
  onClickPostCornerAction?: (post: PostT) => void; // 게시글 우상단 버튼 누름
  CustomActionsComponent?: ComponentType<{ post: PostT }>;
};

const Feeds = observer((feedsProps: FeedsPropsT) => {
  const {
    listKey,
    feeds,
    perspective,
    canOpenPostViewer,
    onClickPostViewer,
    onEnd,
    onClick,
    onClickPostCornerAction,
    CustomActionsComponent,
  } = feedsProps;

  const { palette } = useTheme();

  // 내용이 없다는 안내는 더 상위에서 EmptyState 로 준비한다.
  if (!feeds.length) return null;

  return (
    <>
      <Stack
        key={listKey}
        spacing={0}
        component={TransitionGroup as unknown as React.ElementType}
        sx={{ background: palette.background.default }}
      >
        {feeds.map((feed) => (
          <FeedRow
            key={`${feed.content.type}_${feed.content.id}${
              feed.content.rid
                ? `_${feed.content.rid}`
                : feed.content.tid
                ? `_${feed.content.tid}`
                : ''
            }`}
            feed={feed}
            perspective={perspective}
            canOpenPostViewer={canOpenPostViewer}
            onClickPostViewer={onClickPostViewer}
            onClickFeed={onClick}
            onClickPostCornerAction={onClickPostCornerAction}
            CustomActionsComponent={CustomActionsComponent}
          />
        ))}
      </Stack>
      <LoadMoreSentinel onVisible={onEnd} />
    </>
  );
});
export default Feeds;
